import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import type { WalletUpcomingPayments } from '../../../../queries/pxtraCard';
import { ErrorCircleFilledIcon } from '../../../icons';
import { cn } from '../../../util';
import { walletAlertModel } from './walletAlertModel';

type Props = { upcoming: WalletUpcomingPayments; balanceCents: number };

/** Both severities carry the filled „!“, which FeedbackAlert's per-severity icons do not offer. */
export const WalletAlert: FC<Props> = ({ upcoming, balanceCents }) => {
  const { t } = useTranslation();
  const model = walletAlertModel(t, upcoming, balanceCents);
  if (!model) return null;

  const isError = model.severity === 'error';

  return (
    <div
      role={isError ? 'alert' : 'status'}
      data-testid="wallet-alert"
      data-severity={model.severity}
      className={cn(
        'flex items-start gap-3 rounded p-4 ring-1 ring-inset forced-colors:outline forced-colors:outline-1',
        isError
          ? 'bg-red-50 text-red-700 ring-red-200'
          : 'bg-green-50 text-green-700 ring-green-200'
      )}
    >
      <ErrorCircleFilledIcon
        className={cn('h-6 w-6 shrink-0', isError ? 'text-red-600' : 'text-green-600')}
      />
      <div className={cn('flex flex-col', isError && 'gap-2')}>
        <span className="text-base font-medium">{model.title}</span>
        <span className="text-base">{model.text}</span>
      </div>
    </div>
  );
};
